import { render, staticRenderFns } from "./enterCommunityList.vue?vue&type=template&id=38920020&scoped=true"
import script from "./enterCommunityList.vue?vue&type=script&lang=js"
export * from "./enterCommunityList.vue?vue&type=script&lang=js"
import style0 from "./enterCommunityList.vue?vue&type=style&index=0&id=38920020&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38920020",
  null
  
)

export default component.exports